import axios from "axios";
import { getIdToken } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "./firebase";

export default async function notify(title, message) {

    try {

        let notifDoc = (await getDoc(doc(db, "notifications/xVvJ0cgMw4Y1xItNteiSF15fn5O2"))).data()

        let token = notifDoc?.token

        if(token) {

            const authorization = await getIdToken(auth.currentUser)

            await axios.post("https://us-central1-bindoo-collectives.cloudfunctions.net/api/notify", {
                token,
                message: message || "New order on bindoo app",
                title: title || localStorage.getItem("name"),
            }, { headers: { authorization: "Bearer " + authorization }})

        }
      

    } catch(err) {
        console.log("error: ", err?.response?.data, err?.response, err.message)
    }

}